module.exports = __webpack_public_path__ + "static/img/dyItem1.d67ef3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/dyItem1.png
// module id = z6hl
// module chunks = 0